export default __webpack_public_path__ + "6ff9c0a89756d4e4ab327fb9336c18c1.wav";